"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapturePreview = exports.CapturePreviewType = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const theme_1 = require("../../components/theme");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const classnames_1 = require("../../util/classnames");
const hidden_image_icon_1 = require("../hidden.image.icon/hidden.image.icon");
const capture_preview_style_1 = require("./capture.preview.style");
(0, theme_1.addStyles)(capture_preview_style_1.Style);
var CapturePreviewType;
(function (CapturePreviewType) {
    CapturePreviewType["THUMBNAIL"] = "thumbnail";
    CapturePreviewType["MEDIUM"] = "medium";
    CapturePreviewType["RAW"] = "raw";
})(CapturePreviewType || (exports.CapturePreviewType = CapturePreviewType = {}));
const DEFAULT_THUMBNAIL_SIZE = 180;
exports.CapturePreview = {
    view(collection, capture, ctx = { type: CapturePreviewType.THUMBNAIL }) {
        const draw = services_1.Services.DrawState.getIkeDraw(collection, capture.objectId);
        const className = (0, classnames_1.classNames)(capture_preview_style_1.CSS.container, ctx.className, {
            [capture_preview_style_1.CSS.selectable]: typeof ctx.action === 'function',
            [capture_preview_style_1.CSS.selected]: ctx.selected,
            [capture_preview_style_1.CSS.hiddenCapture]: draw.state.imageVisibilityHidden,
        });
        const title = ctx.title;
        const onclick = ctx.action;
        // Select image URL based on preview type
        let src;
        if (ctx.type === CapturePreviewType.THUMBNAIL && capture.thumbnail) {
            src = capture.thumbnail.url;
        }
        else if (ctx.type === CapturePreviewType.MEDIUM && capture.medium) {
            src = capture.medium.url;
        }
        else {
            src = capture.file.url;
        }
        const size = {
            width: DEFAULT_THUMBNAIL_SIZE,
            height: DEFAULT_THUMBNAIL_SIZE,
        };
        if (ctx.size) {
            size.width = ctx.size;
            size.height = ctx.size;
        }
        const renderCtx = Object.assign(Object.assign({ draw }, (ctx.type === CapturePreviewType.THUMBNAIL && { size })), { units: services_1.Services.UserSettings.units, isThumbnail: ctx.type === CapturePreviewType.THUMBNAIL, isInteractive: false, isEditable: false, scale: core_shared_1.SVGRenderer.scaleUI(draw.state, ctx.type === CapturePreviewType.THUMBNAIL) });
        const hiddenIcon = draw.state.imageVisibilityHidden ? hidden_image_icon_1.HiddenImageIcon.view() : null;
        const dateElement = (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.date }, services_1.Services.DateTime.formatDate(capture.collectedAt.iso));
        // NOTE: Brightness adjustment check was removed because it caused inconsistent behavior:
        // - When brightness was modified, the image showed annotations
        // - When brightness was not modified, annotations were hidden
        // - Now always show just the image
        if (!ctx.crosshair && !ctx.truesize) {
            const wrapperClass = (0, classnames_1.classNames)(capture_preview_style_1.CSS.wrapper, {
                [capture_preview_style_1.CSS.hiddenCapture]: draw.state.imageVisibilityHidden,
            });
            return (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.container, title, onclick }, (0, mithril_1.m)('div', { className: wrapperClass }, [(0, mithril_1.m)('img', { className: capture_preview_style_1.CSS.image, src }), hiddenIcon, dateElement]));
        }
        if (ctx.truesize) {
            return (0, mithril_1.m)('div', { className, title, onclick }, [
                (0, mithril_1.m)('img', {
                    className: capture_preview_style_1.CSS.image,
                    src,
                }),
                (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.overlay }, core_shared_1.SVGRenderer.view(renderCtx)),
                ctx.icon ? (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.photomeasure }) : null,
                hiddenIcon,
                dateElement,
            ]);
        }
        return (0, mithril_1.m)('div', { className, title, onclick }, [
            (0, mithril_1.m)('img', {
                className: capture_preview_style_1.CSS.image,
                src,
            }),
            draw.state.brightness !== 1 ? (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.overlay }, core_shared_1.SVGRenderer.view(renderCtx)) : null,
            ctx.crosshair ? (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.crosshair }) : null,
            hiddenIcon,
            dateElement,
        ]);
    },
};
//# sourceMappingURL=capture.preview.js.map